import type { DisplayDescriptor } from './types';

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

function previewValue(value: unknown): string | undefined {
  if (value === undefined || value === null) return undefined;
  if (typeof value === 'string' && !value.trim()) return undefined;
  return String(value);
}

/** headless 预览行：label 为已解析文案（非 i18n key） */
export function previewRowLiteral(id: string, group: string, label: string, value: unknown): DisplayDescriptor {
  return {
    id,
    group,
    label,
    value: previewValue(value),
  };
}

/** headless 预览行：label 通过 i18n key 解析 */
export function previewRow(
  id: string,
  group: string,
  labelKey: string,
  value: unknown,
  t: TranslateFn,
  labelOptions?: Record<string, unknown>,
): DisplayDescriptor {
  return {
    id,
    group,
    label: t(labelKey, labelOptions),
    value: previewValue(value),
  };
}
